
import React, { useState } from 'react';
import { Dropdown, Checkbox } from 'carbon-components-react';
import "global.scss";
import i18n from "../../i18n";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { boolean, number, select, object, text } from '@storybook/addon-knobs';
import {
    Button, SelectItem, DatePicker, DatePickerInput, TimePicker,
    TimePickerSelect,
    ContentSwitcher,
    Switch,
    FormGroup,
    RadioButton,
    RadioButtonGroup,
    FormLabel,
    Select,
    SelectItemGroup

} from 'carbon-components-react';
// import 'moment/locale/ja';
var moment = require('moment');
require("./_set-frequency.scss");
const SetFrequency = (props) => {
    let user = JSON.parse(localStorage.getItem('user'));
    const setExpiryDate = i18n.t('manageschedule.ExpiryDate');
    const StartDate = i18n.t('manageschedule.StartDate')
    const timeprops = {
        timepicker: () => ({
            pattern: text(
                'Regular expression for the value (pattern in <TimePicker>)',
                '(1[012]|[1-9]):[0-5][0-9](\\s)?'
            ),
            placeholder: text(
                'Placeholder text (placeholder in <TimePicker>)',
                'hh:mm'
            ),
            disabled: boolean('Disabled (disabled in <TimePicker>)', false),
            light: boolean('Light variant (light in <TimePicker>)', false),
            invalid: boolean(
                'Show form validation UI (invalid in <TimePicker>)',
                false
            ),
            invalidText: text(
                'Form validation UI content (invalidText in <TimePicker>)',
                'A valid value is required'
            ),
            maxLength: number('Maximum length (maxLength in <TimePicker>)', 5),
            size: select('Field size (size)', sizes, undefined) || undefined,
        }),
        select: () => ({
            disabled: boolean('Disabled (disabled in <TimePickerSelect>)', false),
            labelText: text(
                'Label text (labelText in <TimePickerSelect>)',
                'Please select'
            ),
            iconDescription: text(
                'Trigger icon description (iconDescription in <TimePickerSelect>)',
                'open list of options'
            ),
        }),
    };

    const sizes = {
        'Extra large size (xl)': 'xl',
        'Default size': undefined,
        'Small size (sm)': 'sm',
    };

    // const checkboxes = [
    //     {
    //         name: "Mon",
    //         key: "Mon",
    //         labelText: "Mon"
    //     },
    //     {
    //         name: "Tue",
    //         key: "Tue",
    //         labelText: "Tue"
    //     },
    //     {
    //         name: "Wed",
    //         key: "Wed",
    //         labelText: "Wed"
    //     },
    //     {
    //         name: "Thu",
    //         key: "Thu",
    //         labelText: "Thu"
    //     },
    //     {
    //         name: "Fri",
    //         key: "Fri",
    //         labelText: "Fri"
    //     }
    // ];

    // const checkboxesToRender = checkboxes.map(item => {
    //     return (
    //         <label key={item.key}>
    //             <Checkbox
    //                 labelText={item.labelText}
    //                 checked={props.checked}
    //                 // onChange= (e) => {props.handleCheckedWeek}
    //                 onChange={(e) => props.handleCheckedWeek(e)}
    //                 id={item.name}
    //             />
    //         </label>
    //     );
    // });
    const [showModal, setshowModal] = useState(false);
    if (user !== null && user.access_token !== null) {
        return (
            <>
                <div className="expiryDate">
                    <div className="bx--grid">
                        <div className="bx--row">
                            <div className="bx--col bx--col-sm-4">
                                <div className="bx--label">{StartDate}</div>
                                <DatePicker className="time-filter-basic-info" datePickerType="single" onChange={(e) => props.handleTimeChange('startDate', e)}>
                                    <DatePickerInput
                                        disabled={props.review}
                                        required
                                        invalid={props.valid_sdate}
                                        helperText=""
                                        invalidText={props.helptext_sdate}
                                        placeholder="yyyy/mm/dd"
                                        id="date-picker-single"
                                        value={props.timeFilterSelections.startDate}
                                        onChange={props.handletimeFilterSelectionsChange}
                                    />
                                </DatePicker>
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <div className="bx--label">{i18n.t('editScheduleRecommendation.startTime')}</div>
                                <TimePicker id="time-picker" {...timeprops.timepicker()}
                                    disabled={props.review}
                                    required
                                    invalid={props.valid_stime}
                                    helperText=""
                                    invalidText={props.helptext_stime}
                                    value={props.timeFilterSelections.startTime}
                                    onBlur={(e) => props.handleTimeChange('startTime', e)}>
                                    <TimePickerSelect id="time-picker-select-1" value={props.timeFilterSelections.startAMPM} onChange={(e) => props.handleTimeChange('startAMPM', e)}>
                                        <SelectItem value="AM" text="AM" />
                                        <SelectItem value="PM" text="PM" />
                                    </TimePickerSelect>
                                </TimePicker>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="expiryDate">
                    <div className="bx--grid">
                        <div className="bx--row">
                            <div className="bx--col bx--col-sm-4">
                                <div className="bx--label">{setExpiryDate}</div>
                                <DatePicker className="time-filter-basic-info" datePickerType="single" onChange={(e) => props.handleTimeChange('endDate', e)}>
                                    <DatePickerInput
                                        disabled={props.review}
                                        required
                                        invalid={props.valid_edate}
                                        helperText=""
                                        invalidText={props.helptext_edate}
                                        placeholder="yyyy/mm/dd"
                                        id="date-picker-single"
                                        value={props.timeFilterSelections.endDate}
                                        onChange={props.handletimeFilterSelectionsChange}
                                    />
                                </DatePicker>
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <div className="bx--label">{i18n.t('editScheduleRecommendation.expiryTime')}</div>
                                <TimePicker id="time-picker"
                                    {...timeprops.timepicker()}
                                    disabled={props.review}
                                    required
                                    invalid={props.valid_etime}
                                    helperText=""
                                    invalidText={props.helptext_etime} value={props.timeFilterSelections.endTime} onBlur={(e) => props.handleTimeChange('endTime', e)}>
                                    <TimePickerSelect id="time-picker-select-1" value={props.timeFilterSelections.endAMPM} onChange={(e) => props.handleTimeChange('endAMPM', e)}>
                                        <SelectItem value="AM" text="AM" />
                                        <SelectItem value="PM" text="PM" />
                                    </TimePickerSelect>
                                </TimePicker>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="set-frequency margin-bottom-10px">
                    <div className="bx--grid">
                        <div className="bx--row">
                            <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    disabled={props.review}
                                    ariaLabel="Occurance"
                                    id="occurance"
                                    items={props.occurances}
                                    titleText={i18n.t('editScheduleRecommendation.occurs')}
                                    label='Select'
                                    onChange={({ selectedItem }) => props.handleChangeOccurance(selectedItem)}
                                    selectedItem={props.currentOccurance}
                                />
                            </div>
                            {/* <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    ariaLabel="Frequency"
                                    id="frequency"
                                    items={props.frequency}
                                    titleText="Every"
                                    label='Select'
                                    onChange={({ selectedItem }) => props.handleChangeFrequency(selectedItem)}
                                    selectedItem={props.currentFrequency}
                                />
                                <label>{props.frequencytext}</label>
                            </div> */}
                        </div>
                        {/* <div className="bx--row week-day">
                            
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeekMon} labelText="Mon" id="mon" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeekTue} labelText="Tue" id="tue" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeek} labelText="Wed" id="wed" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeek} labelText="Thu" id="thu" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeek} labelText="Fri" id="fri" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeek} labelText="Sat" id="sat" />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Checkbox checked={props.checked} onChange={props.handleCheckedWeek} labelText="Sun" id="sun" />
                            </div>
                        </div> */}
                    </div>
                </div>

                {
                    (props.currentOccurance === "Minutely" || props.currentOccurance === "Hourly") &&

                    <div className="set-frequency">
                        <div className="bx--grid">
                            <div className="bx--row">
                                <div className="bx--col bx--col-sm-4">
                                    <label className="frequency">{i18n.t('scheduleRecommendation.between')}</label>
                                    <TimePicker id="time-picker-between"
                                    disabled={props.review}
                                    required
                                    invalid={props.valid_stime}
                                    helperText=""
                                    invalidText={props.helptext_stime}
                                    value={props.timeFilterSelections.startTime}
                                    onBlur={(e) => props.handleTimeChange('startTime', e)}>
                                    <TimePickerSelect id="time-picker-select-1" value={props.timeFilterSelections.startAMPM} onChange={(e) => props.handleTimeChange('startAMPM', e)}>
                                        <SelectItem value="AM" text="AM" />
                                        <SelectItem value="PM" text="PM" />
                                    </TimePickerSelect>
                                </TimePicker>
                                </div>
                                <div className="bx--col bx--col-sm-4">
                                    <label className="frequency">{i18n.t('scheduleRecommendation.and')}</label>
                                    <TimePicker id="time-picker-and">
                                        <TimePickerSelect id="time-picker-select-and" >
                                            <SelectItem disabled={props.review} value="AM" text="AM" />
                                            <SelectItem disabled={props.review} value="PM" text="PM" />
                                        </TimePickerSelect>
                                    </TimePicker>
                                </div>
                                <div className="frequency margin-left-15px">
                                    <Dropdown
                                        disabled={props.review}
                                        ariaLabel="Frequency"
                                        id="frequency"
                                        items={props.frequency}
                                        titleText="Every"
                                        label=''
                                        className="every"
                                        onChange={({ selectedItem }) => props.handleChangeFrequency(selectedItem)}
                                        selectedItem={props.currentFrequency}
                                    />
                                </div>

                                {/* <Checkbox className="" checked={props.checked} onChange={props.handleCheckedWeek}
                                    labelText="Only on days in the calendar" id="calendar" /> */}


                            </div>
                        </div>
                    </div>

                } {
                    (props.currentOccurance === "Daily") &&
                    <div className="set-frequency margin-top-15px">
                        <div className="bx--grid">
                            <div className="bx--row">
                                <div className="bx--col bx--col-sm-4">
                                    <Checkbox disabled={props.review} checked={props.checked} onChange={props.handleCheckedWeek}
                                        labelText={i18n.t('editScheduleRecommendation.onlyDaysInCal')} id="calendar" />
                                    <Dropdown
                                        disabled={props.review}
                                        ariaLabel="Frequency"
                                        id="frequency"
                                        items={props.frequency}
                                        titleText={i18n.t('editScheduleRecommendation.every')}
                                        label='Select'
                                        onChange={({ selectedItem }) => props.handleChangeFrequency(selectedItem)}
                                        selectedItem={props.currentFrequency}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

                } {
                    (props.currentOccurance === "Weekly") &&
                    <div className="monthly">
                        <div className="bx--grid">
                            <div className="bx--row">
                                <RadioGroup
                                    disabled={props.review}
                                    aria-label="weekly"
                                    name="weekly"
                                    value={props.radiobuttonvalueweekly}
                                    onChange={(e) => props.handleWeeklyRadioChange(e)}>
                                    <div className="bx--col bx--col-sm-4">
                                        <FormControlLabel
                                            disabled={props.review}
                                            value="radiovalueweekly1"
                                            control={<Radio color="primary" checked={props.radioweeklyFlag1} />}
                                            label={i18n.t('scheduleRecommendation.on')}
                                            labelPlacement="start"
                                        /> <label>{moment(props.timeFilterSelections.start_time).format('dddd')}s</label>
                                    </div>
                                    <div className="bx--col bx--col-sm-4">
                                        <FormControlLabel
                                            disabled={props.review}
                                            value="radiovalueweekly2"
                                            control={<Radio color="primary" checked={props.radioweeklyFlag2} />}
                                            label={i18n.t('scheduleRecommendation.onThe')}
                                            labelPlacement="start"
                                        />
                                        <Select
                                            disabled={props.review}
                                            value={props.calendarNameOptions}
                                            onChange={(e) => props.handleCalendarNameOptionsChange(e)}
                                            // className={classes.selectEmptyFirstLast}
                                            disabled={props.dropdownWeeklyFlag}
                                            labelText=""
                                        >
                                            <option value="First">{i18n.t('scheduleRecommendation.first')}</option>
                                            <option value="Last">{i18n.t('scheduleRecommendation.last')}</option>
                                        </Select>
                                        <label className="working-day">{i18n.t('scheduleRecommendation.workingDayCalLabel')}</label>

                                    </div>
                                    <div className="bx--col bx--col-sm-4">
                                        <Select
                                            disabled={props.review}
                                            labelText=""
                                            value={props.calendarName}
                                            onChange={(e) => props.handleCalendarNameChange(e)}
                                            // className={classes.selectEmpty}
                                            disabled={props.dropdownWeeklyFlag}
                                        >
                                            {/* {calendarOptions} */}
                                        </Select>
                                        {/* <label className={classes.laa}>{i18n.t('scheduleRecommendation.calendar')}</label> */}
                                    </div>
                                </RadioGroup>

                            </div>
                        </div>
                    </div>

                } {
                    (props.currentOccurance === "Monthly") &&
                    <div className="monthly">
                        <RadioGroup
                            disabled={props.review}
                            aria-label="monthly"
                            name="monthly"
                            value={props.radiobuttonvalue}
                            onChange={props.handleRadioChange}
                        ><div>
                                <FormControlLabel
                                    disabled={props.review}
                                    value="radiovalue1"
                                    control={<Radio color="primary" checked={props.dropdownFlag1} />}
                                    label={i18n.t('scheduleRecommendation.onThe')}
                                    labelPlacement="start"
                                /> <label>{moment(props.timeFilterSelections.startTime).format('Do')}</label>
                            </div>
                            <div>
                                <FormControlLabel
                                    disabled={props.review}
                                    value="radiovalue2"
                                    control={<Radio color="primary" checked={props.dropdownFlag} />}
                                    label={i18n.t('scheduleRecommendation.onThe')}
                                    labelPlacement="start"
                                />
                                <Select
                                    labelText=""
                                    disabled={props.review}
                                    value={props.frequencyWeek}
                                    onChange={(e) => props.handleScheduleMonthlyDay(e)}
                                    // className={ }
                                    disabled={props.selectFlag}
                                >
                                    <option value="First">{i18n.t('scheduleRecommendation.first')}</option>
                                    <option value="Second">{i18n.t('scheduleRecommendation.second')}</option>
                                    <option value="Third">{i18n.t('scheduleRecommendation.third')}</option>
                                    <option value="Fourth">{i18n.t('scheduleRecommendation.fourth')}</option>
                                    <option value="Fifth">{i18n.t('scheduleRecommendation.fifth')}</option>
                                    <option value="Last">{i18n.t('scheduleRecommendation.last')}</option>
                                </Select>

                                <Select
                                    disabled={props.review}
                                    labelText=""
                                    value={props.frequencyWeekDay}
                                    onChange={(e) => props.handleScheduleMonthlyDayName(e)}
                                    // className={ }
                                    disabled={props.selectFlag}
                                >
                                    <option value="Monday">{i18n.t('scheduleRecommendation.monday')}</option>
                                    <option value="Tuesday">{i18n.t('scheduleRecommendation.tuesday')}</option>
                                    <option value="Wednesday">{i18n.t('scheduleRecommendation.wednesday')}</option>
                                    <option value="Thursday">{i18n.t('scheduleRecommendation.thursday')}</option>
                                    <option value="Friday">{i18n.t('scheduleRecommendation.friday')}</option>
                                    <option value="Saturday">{i18n.t('scheduleRecommendation.saturday')}</option>
                                    <option value="Sunday">{i18n.t('scheduleRecommendation.sunday')}</option>
                                </Select>
                                {/* <label className={classes.laa}>of the month</label> */}
                            </div>
                            <div style={{ paddingTop: '10px' }}>
                                <FormControlLabel
                                    disabled={props.review}
                                    value="radiovalue3"
                                    control={<Radio color="primary" checked={props.dropdownFlagCalendar} />}
                                    label={i18n.t('scheduleRecommendation.onThe')}
                                    labelPlacement="start"
                                />
                                <Select
                                    disabled={props.review}
                                    labelText=""
                                    value={props.calendarNameOptions}
                                    onChange={(e) => props.handleCalendarNameOptionsChange(e)}
                                    // className={ }
                                    disabled={props.selectFlagCalendar}
                                >
                                    <option value="First">{i18n.t('scheduleRecommendation.first')}</option>
                                    <option value="Last">{i18n.t('scheduleRecommendation.last')}</option>
                                </Select>
                                <label
                                // className={ }
                                >{i18n.t('scheduleRecommendation.workingDayCalLabel')}</label>
                            </div>
                            <div style={{ paddingTop: '10px', paddingLeft: '70px' }}>
                                <Select
                                    disabled={props.review}
                                    labelText=""
                                    value={props.calendarName}
                                    onChange={(e) => props.handleCalendarNameChange(e)}
                                    // className={ }
                                    disabled={props.selectFlagCalendar}
                                >
                                    {/* {calendarOptions} */}
                                </Select>
                                {/* <label className={classes.laa}>{i18n.t('scheduleRecommendation.calendar')}</label> */}
                            </div>
                        </RadioGroup>
                    </div>
                }

            </>
        )
    } else {
        return (
            <div>
                <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
            </div>
        );
    }

}

export default SetFrequency